/* eslint-disable max-len */
import { connect } from "react-redux";
import {
  initializeScreen,
  initializePrevScreen,
  assesmentChanged,
  fieldChanged,
  pickPharmacyOnMap,
  setFilters,
  resetFilters,
  setDetailProviderData,
  resetDetailProviderData,
  setDetailProviderFieldsData,
  setDetailCareTeamProviderFieldsData,
  setTreatmentData,
  deleteTreatmentData,
  updateTreatmentData,
  resetTreatmentData,
  setTreatmentToEdit,
  resetTreatmentToEdit,
  resetFormState,
  setValidation,
  deleteFromFormState,
  resetValidation,
  addToast,
  removeToast,
  setFieldValidation,
  resetFieldValidation,
  resetFieldValidationAll,
  dependentStoredSuccess,
  resetDependent,
  careRecipientStoredSuccess,
  resetCareRecipient,
  addTrackingEvent,
  setFormGroupErrors,
  resetReduxStore,
  setSelectedDate,
  setSelectedTime,
  clearDateTimeSelection,
  addCallToActionButtonIsLoading,
  removeCallToActionButtonIsLoading,
  setFormState,
  setFlowStatusLoading,
  setShowHud,
  resetShowHud,
  clearDialogFlow,
  initializeDialog,
  resetActionField,
  setFormErrorsFromBack,
  piiCollectedSuccess,
  setPageNumber,
  setSelectedListItem,
  onItemSelected,
  resetItemSelected,
  resetFormFields,
  resetFieldsValidation
} from "../redux/actions";
import { TdFlowApp } from "./td-flow";
import {
  fetchFlow,
  saveMedicalHistory,
  prevScreen,
  searchPharmacies,
  searchRetailPharmacies,
  capsuleDeliverableCheck,
  startOver,
  nextScreen,
  exitScreen,
  uploadPhoto,
  uploadPhotoGeneric,
  uploadPhotoMHD,
  uploadPhotoEMO,
  uploadPhotoMHN,
  uploadPhotoVideoRoom,
  uploadPhotoEDIS,
  updateConsultState,
  updateScreensHistoryFlow,
  updateScreenHistoryAction,
  getCurrentLocation,
  sendTrackingEvents,
  initializeTdFlow,
  fetchAvailableTimes,
  fetchPostFile,
  returnToInbox
} from "../redux/thunks";

/*
TODO place this somewhere else
Example usage:

 const theme = {
   Button: MyButtonComponent,
   Field: MyFieldComponent,
 }
 const initialRequest = {
   url: "/screens/request_consult/start",
   formState: { logged_in_member_id: loginData.domain_id }
 };

 const unmaskPhoneNumber = v => v.replace(/\D+/g, '');
 const fieldConfigurations {
    masks: {
      PhoneNumber: {
        mask: '(999) 999-9999',
        maskChar: '_',
        placeholder: '',
        id: '',
        label: '',
        specificity: '',
        component: 'text'
      },

      Number: {
        type: 'number'
      }
    },
    unmasks: {
      PhoneNumber: unmaskPhoneNumber
    },
    fieldAttributes: {
      PhoneNumber: {
        ariaLabel: 'PhoneNumber'
      }
    }
  };

 return <TdFlow initialRequest={initialRequest} theme={theme} fieldConfigurations={fieldConfigurations}/>;
*/

/**
 * @function getScreenIndex
 * @param {Object} data Contains info regarding WebSDK flow (i.e. actions, screens, response data, fields)
 * @param {Array} history Array of objects containing name, url, and index of screens in flow
 * @returns {Number} Screen index of WebSDK flow
 */
export const getScreenIndex = ({ data, history }) => {
  if (!history.length) {
    return 0;
  }
  const { name } = history[0];
  if (!name || !data) {
    return history[0].index;
  }
  const index = data.screens.findIndex(screen => screen.name === name);
  return index === -1 ? history[0].index : index;
};

/**
 * Connects TdFlowApp to Redux store
 * @function connect
 * @param {Function} mapStateToProps Receives entire Redux store state and
 * selects data to be accessible via props in TdFlowApp
 * These values will determine if TdFlowApp needs to rerender
 * @param {Object} mapDispatchToProps Object shorthand for mapDispatchToProps argument;
 * React-Redux automatically calls bindActionCreators behind the scenes
 * @see [React-Redux documentation]{@link https://react-redux.js.org/using-react-redux/connect-mapstate}
 */
export default connect(
  ({ tdFlow }) => ({
    data: tdFlow.data,
    screenIndex: getScreenIndex(tdFlow),
    history: tdFlow.history,
    lastNavAction: tdFlow.lastNavAction,
    screenInitialized: tdFlow.screenInitialized,
    flowStatus: tdFlow.flowStatus,
    validation: tdFlow.validation,
    toasts: tdFlow.toasts,
    formState: tdFlow.formState,
    assesmentsState: tdFlow.assesmentsState,
    pharmacies: tdFlow.pharmacies,
    providerDetailData: tdFlow.providerDetailData,
    providerDetailFieldsData: tdFlow.providerDetailFieldsData,
    careTeamProviderDetailFieldsData: tdFlow.careTeamProviderDetailFieldsData,
    dateTimeSelection: tdFlow.dateTimeSelection,
    callToActionButton: tdFlow.callToActionButton,
    dermTreatmentData: tdFlow.dermTreatmentData,
    treatmentToEditData: tdFlow.treatmentToEditData,
    screensHistoryFlow: tdFlow.screensHistoryFlow,
    providers: tdFlow.providers,
    screenParams: tdFlow.screenParams,
    consultStatus: tdFlow.consultStatus,
    capsuleDelivery: tdFlow.capsuleDelivery,
    fieldValidation: tdFlow.fieldValidation,
    dependentStored: tdFlow.dependentStored,
    careRecipientStored: tdFlow.careRecipientStored,
    trackingEvents: tdFlow.trackingEvents,
    showHud: tdFlow.showHud,
    formGroupErrors: tdFlow.formGroupErrors,
    dialogInitialized: tdFlow.dialogInitialized,
    settings: tdFlow.settings,
    isGlobalDialogShown: tdFlow.isGlobalDialogShown,
    isPiiCollected: tdFlow.isPiiCollected,
    pageNumber: tdFlow.pageNumber,
    selectedListItem: tdFlow.selectedListItem,
    isItemSelected: tdFlow.isItemSelected
  }),
  {
    fetchFlow,
    saveMedicalHistory,
    initializeScreen,
    initializePrevScreen,
    fieldChanged,
    assesmentChanged,
    nextScreen,
    prevScreen,
    exitScreen,
    searchPharmacies,
    searchRetailPharmacies,
    capsuleDeliverableCheck,
    pickPharmacyOnMap,
    setFilters,
    resetFilters,
    startOver,
    resetFormState,
    setFormState,
    deleteFromFormState,
    uploadPhoto,
    uploadPhotoGeneric,
    uploadPhotoMHD,
    uploadPhotoEMO,
    uploadPhotoMHN,
    uploadPhotoVideoRoom,
    uploadPhotoEDIS,
    setDetailProviderData,
    resetDetailProviderData,
    setDetailProviderFieldsData,
    setDetailCareTeamProviderFieldsData,
    setTreatmentData,
    deleteTreatmentData,
    updateTreatmentData,
    resetTreatmentData,
    setTreatmentToEdit,
    resetTreatmentToEdit,
    setValidation,
    resetValidation,
    addToast,
    removeToast,
    updateConsultState,
    updateScreensHistoryFlow,
    updateScreenHistoryAction,
    setFieldValidation,
    resetFieldValidation,
    resetFieldValidationAll,
    dependentStoredSuccess,
    resetDependent,
    careRecipientStoredSuccess,
    resetCareRecipient,
    getCurrentLocation,
    addTrackingEvent,
    sendTrackingEvents,
    setFormGroupErrors,
    resetReduxStore,
    initializeTdFlow,
    fetchAvailableTimes,
    setSelectedDate,
    setSelectedTime,
    clearDateTimeSelection,
    removeCallToActionButtonIsLoading,
    addCallToActionButtonIsLoading,
    setFlowStatusLoading,
    setShowHud,
    resetShowHud,
    clearDialogFlow,
    initializeDialog,
    resetActionField,
    setPageNumber,
    setSelectedListItem,
    onItemSelected,
    resetItemSelected,
    setFormErrorsFromBack,
    piiCollectedSuccess,
    fetchPostFile,
    resetFormFields,
    resetFieldsValidation,
    returnToInbox
  }
)(TdFlowApp);
